import { FC, ReactNode } from 'react';

import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import { IconButton } from '@mui/material';
import { Stack } from '@mui/system';

type CustomCalendarsFormColumnProps = {
  field: ReactNode;
  isSyncButtonVisible: boolean;
  isSyncing: boolean;
  onSyncCalendar: () => void;
};

const CustomCalendarsFormColumn: FC<CustomCalendarsFormColumnProps> = ({
  field,
  isSyncButtonVisible,
  isSyncing,
  onSyncCalendar,
}) => {
  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      {field}
      {isSyncButtonVisible && (
        <IconButton
          size='small'
          onClick={() => {
            if (!isSyncing) {
              void onSyncCalendar();
            }
          }}
        >
          <SyncRoundedIcon
            sx={{
              '@keyframes spin': {
                from: { transform: 'rotate(0deg)' },
                to: { transform: 'rotate(-360deg)' },
              },
              'animation': isSyncing ? 'spin 1s infinite' : 'none',
            }}
          />
        </IconButton>
      )}
    </Stack>
  );
};

export default CustomCalendarsFormColumn;
